import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import { getFirestore } from "firebase/firestore";
import { getAuth, setPersistence, browserSessionPersistence, sendPasswordResetEmail, sendEmailVerification, updateEmail } from "firebase/auth";
import { getStorage } from 'firebase/storage';

//check all env variables if not undefined
if (!process.env.REACT_APP_FIREBASE_API_KEY || 
  !process.env.REACT_APP_FIREBASE_AUTH_DOMAIN || 
  !process.env.REACT_APP_FIREBASE_PROJECT_ID || 
  !process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PRODUCTION || 
  !process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_STAGING || 
  !process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID || 
  !process.env.REACT_APP_FIREBASE_APP_ID || 
  !process.env.REACT_APP_FIREBASE_MEASUREMENT_ID || 
  !process.env.REACT_APP_FIRESTORE_DB_PRODUCTION || 
  !process.env.REACT_APP_FIRESTORE_DB_DEV) {
  throw new Error('Missing Firebase ENV variables');
}

const APP_ENV = process.env.REACT_APP_ENV;

const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: APP_ENV === 'prod' ? process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_PRODUCTION : process.env.REACT_APP_FIREBASE_STORAGE_BUCKET_STAGING,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase App
const app = initializeApp(firebaseConfig);

// Initialize Firebase Services
const auth = getAuth(app);
const analytics = getAnalytics(app);
const db = getFirestore(app, APP_ENV === 'prod' ? process.env.REACT_APP_FIRESTORE_DB_PRODUCTION : process.env.REACT_APP_FIRESTORE_DB_DEV);
const storage = getStorage(app);

setPersistence(auth, browserSessionPersistence);
export { auth, app, db, analytics, storage, APP_ENV as env };
